import { useCacheInvalidationContext } from '@/contexts/CacheInvalidationContext';

export const useCacheInvalidationListener = (): number => {
  return useCacheInvalidationContext();
};
